import { render, staticRenderFns } from "./EditShiftAutomation.vue?vue&type=template&id=37676f20&"
import script from "./EditShiftAutomation.vue?vue&type=script&lang=ts&"
export * from "./EditShiftAutomation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports